import { render, staticRenderFns } from "./DNSMonitoringHistory.vue?vue&type=template&id=57a56f5e&scoped=true&"
import script from "./DNSMonitoringHistory.vue?vue&type=script&lang=js&"
export * from "./DNSMonitoringHistory.vue?vue&type=script&lang=js&"
import style0 from "./DNSMonitoringHistory.vue?vue&type=style&index=0&id=57a56f5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a56f5e",
  null
  
)

export default component.exports